import { useEffect, useMemo } from 'react';
import useGetSecondarySystems from '../../hooks/useGetSecondarySystems';
import DropDown from '../Dropdown';
import { SecondarySystemsDropdownContainer } from './styles';

const otherOption = {
  label: 'Other',
  value: 'Other',
};

function SecondarySystemsDropdown({ value, setDataFunc, isDisabled, hasOtherOption = false, setOtherData }) {
  const { secondarySystems, isLoading } = useGetSecondarySystems();

  const secondarySystemsOptions = useMemo(() => {
    let options = [];
    if (secondarySystems) {
      options = secondarySystems.map((secondarySystem) => ({
        value: secondarySystem.id,
        label: `${secondarySystem.code} - ${secondarySystem.name}`,
      }));
    }
    if (hasOtherOption) {
      options.push(otherOption);
    }
    return options;
  }, [secondarySystems]);

  const onChange = (option) => {
    const chosenSecondarySystemObj = secondarySystems.find((secondarySystem) => secondarySystem.id === option.value);
    const newValues = {
      secondarySystem: null,
      secondarySystemId: null,
    };
    if (chosenSecondarySystemObj || option.value === otherOption.value) {
      newValues.secondarySystem = option.label;
      newValues.secondarySystemId = option.value;
    }
    // set None as empty string so it can be displayed correctly
    if (option.value === '') {
      newValues.secondarySystem = option.value;
    }

    setDataFunc(newValues);
  };

  let selectedValue = secondarySystemsOptions.find((secondarySystem) => secondarySystem.label === value)?.value;
  const calculatedValue = value
    ? !selectedValue ? 'Other' : value // if there is a value but not one of the standard options, it's value for Other
    : value === '' ? '' : null;
  if (calculatedValue === 'Other') {
    selectedValue = secondarySystemsOptions.find((secondarySystem) => secondarySystem.label === 'Other')?.value;
  }

  useEffect(() => {
    if (!secondarySystemsOptions) return;
    const isOther =
      value &&
      !secondarySystemsOptions.find(
        (secondarySystem) => secondarySystem.label !== otherOption.value && secondarySystem.label === value
      );
    if (hasOtherOption && isOther) {
      setOtherData({ secondarySystem: value, secondarySystemId: 'Other', otherSecondarySystem: value });
    }
  }, [secondarySystemsOptions]);

  return (
    <SecondarySystemsDropdownContainer>
      <DropDown
        isLoading={isLoading}
        options={secondarySystemsOptions}
        isOptional={true}
        value={selectedValue}
        placeholder='Select secondary system'
        onChange={onChange}
        isDisabled={isDisabled}
      />
    </SecondarySystemsDropdownContainer>
  );
}

export default SecondarySystemsDropdown;
